export default "__VITE_ASSET__BpgYU7Os__"